export const enneagramDetails = {
  '1': {
    analysis: `당신은 완벽을 추구하는 개혁가입니다. 내면의 비판적인 목소리(Inner Critic)가 강하여 자신과 세상의 모든 것을 옳고 그름의 기준으로 판단하려 합니다. 도덕적 기준과 이상이 매우 높으며, 모든 것을 개선하고 완벽하게 만들고자 하는 강한 충동을 가지고 있습니다.

기본적인 두려움은 부도덕하거나 악하거나 결함이 있는 존재가 되는 것입니다. 이러한 두려움을 극복하기 위해 완벽해지려 노력하며, 높은 기준과 원칙을 세우고 이를 철저히 지키려 합니다.

실제 생활에서는 체계적이고 원칙적인 태도가 돋보입니다. 예를 들어, 업무에서 꼼꼼한 계획을 세우고 실수 없이 완벽하게 실행하려 노력하거나, 도덕적 문제에 대해 확고한 입장을 가지고 개선을 위해 노력합니다.

통합의 방향은 7번 유형의 특성을 건강하게 받아들이는 것입니다. 통합되면 완벽주의적 경직성에서 벗어나 보다 자유롭고 즐거운 태도를 가지게 되며, 실수와 불완전함을 받아들일 수 있게 됩니다. 자신과 타인에 대해 더 관용적이 되며, 삶의 다양한 가능성을 즐길 수 있게 됩니다.

분열의 방향은 4번 유형의 부정적 특성으로 빠져드는 것입니다. 분열되면 자신의 불완전함에 대한 우울감과 열등감에 사로잡히며, 완벽해질 수 없다는 좌절감으로 인해 깊은 상실감을 느낍니다. 비판적인 태도가 더욱 강화되고, 자신과 타인에 대한 분노와 원망이 증가합니다.`,
    development: [
      "완벽하지 않아도 된다는 것을 받아들이고 자신에게 더 관대해지세요",
      "실수를 성장의 기회로 보는 관점을 기르세요",
      "즐거움과 여유를 누리는 시간을 의도적으로 가지세요",
      "다른 사람들의 다양한 관점과 방식을 인정하고 존중하세요",
      "내면의 비판적인 목소리를 알아차리고 그 강도를 조절하세요"
    ]
  },
  '2': {
    analysis: `당신은 타인을 돕고 사랑받기를 갈망하는 조력가입니다. 다른 사람들의 필요와 감정에 매우 민감하며, 도움을 제공함으로써 관계 속에서 자신의 가치를 확인하려 합니다. 사랑과 인정받고 싶은 욕구가 강하며, 이를 위해 끊임없이 타인을 돕고 배려합니다.

기본적인 두려움은 사랑받지 못하고 불필요한 존재가 되는 것입니다. 이러한 두려움을 극복하기 위해 자신이 필요한 사람이 되려 노력하며, 타인의 요구에 민감하게 반응합니다.

실제 생활에서는 뛰어난 공감 능력과 대인관계 기술이 돋보입니다. 예를 들어, 친구나 동료의 고민을 진심으로 경청하고 실질적인 도움을 제공하거나, 타인의 감정 상태를 정확히 파악하여 적절한 지원을 제공합니다.

통합의 방향은 4번 유형의 특성을 건강하게 받아들이는 것입니다. 통합되면 타인의 인정에 덜 의존하게 되며, 자신의 진정한 감정과 욕구를 인식하고 표현할 수 있게 됩니다. 자신만의 독특한 정체성을 발견하고, 진정성 있는 관계를 형성할 수 있습니다.

분열의 방향은 8번 유형의 부정적 특성으로 빠져드는 것입니다. 분열되면 자신의 도움이 거절당하거나 인정받지 못할 때 공격적이고 지배적인 태도를 보이며, 타인을 조종하거나 감정적으로 의존하게 만드는 경향이 강해집니다.`,
    development: [
      "자신의 진정한 감정과 욕구를 인식하고 존중하세요",
      "도움을 주지 않아도 가치 있는 존재임을 기억하세요",
      "건강한 경계선을 설정하고 때로는 '아니오'라고 말하세요",
      "타인의 인정과 감사에 덜 의존하는 방법을 배우세요",
      "자신을 위한 시간과 에너지를 투자하세요"
    ]
  },
  '3': {
    analysis: `당신은 성공 지향적이고 적응력 있는 성취가입니다. 목표 달성과 성과를 통해 자신의 가치를 입증하려 하며, 효율적이고 유능한 이미지를 유지하기 위해 끊임없이 노력합니다. 다른 사람들의 인정과 찬사를 얻는 것에 큰 가치를 둡니다.

기본적인 두려움은 가치 없는 존재가 되는 것입니다. 이러한 두려움을 극복하기 위해 성공적인 이미지를 구축하고 목표를 달성하는 데 집중하며, 실패나 무능력하게 보이는 것을 극도로 꺼립니다.

실제 생활에서는 뛰어난 적응력과 성과 지향적인 태도가 돋보입니다. 예를 들어, 주어진 환경에서 빠르게 성공의 기준을 파악하고 그에 맞춰 자신을 변화시키거나, 효율적으로 목표를 달성하기 위해 전략적으로 행동합니다.

통합의 방향은 6번 유형의 특성을 건강하게 받아들이는 것입니다. 통합되면 겉모습과 성과에 대한 집착에서 벗어나 진정한 자아를 발견하게 되며, 다른 사람들과 더 진실된 관계를 맺을 수 있습니다. 자신의 취약성을 인정하고 타인을 신뢰하며 협력할 수 있게 됩니다.

분열의 방향은 9번 유형의 부정적 특성으로 빠져드는 것입니다. 분열되면 실패나 좌절을 경험할 때 현실도피적 성향을 보이며, 감정을 마비시키고 자신의 진정한 욕구를 무시하게 됩니다. 과도한 업무나 성과 추구로 자신을 소진시킬 수 있습니다.`,
    development: [
      "성과와 이미지를 넘어선 진정한 자아를 탐색하세요",
      "실패와 불완전함도 인간의 자연스러운 모습임을 받아들이세요",
      "진정한 감정과 욕구에 귀 기울이는 시간을 가지세요",
      "다른 사람들에게 취약한 모습을 보이는 것을 두려워하지 마세요",
      "성공의 정의를 다양한 관점에서 재고해보세요"
    ]
  },
  '4': {
    analysis: `당신은 개성적이고 감수성이 풍부한 예술가입니다. 자신만의 독특한 정체성과 의미를 추구하며, 깊은 감정과 창의적 표현을 중요시합니다. 평범함을 거부하고 진정성 있는 자아실현을 갈망합니다.

기본적인 두려움은 정체성이 없거나 평범한 존재가 되는 것입니다. 이러한 두려움을 극복하기 위해 자신만의 독특함을 추구하며, 깊은 감정과 예술적 표현을 통해 자아를 실현하려 합니다.

실제 생활에서는 예술적 감수성과 깊은 통찰력이 돋보입니다. 예를 들어, 다른 사람들이 보지 못하는 아름다움과 의미를 발견하거나, 자신만의 독특한 방식으로 감정과 경험을 창의적으로 표현합니다.

통합의 방향은 1번 유형의 특성을 건강하게 받아들이는 것입니다. 통합되면 감정적 변동성에서 벗어나 더 객관적이고 균형 잡힌 시각을 가지게 되며, 현실적인 목표 설정과 실천이 가능해집니다. 자신의 이상을 구체적인 행동으로 옮길 수 있게 됩니다.

분열의 방향은 2번 유형의 부정적 특성으로 빠져드는 것입니다. 분열되면 타인의 관심과 인정을 과도하게 추구하며, 감정적 조종이나 극적인 행동을 통해 주목받으려 합니다. 자기연민에 빠지거나 타인에 대한 감정적 의존도가 높아질 수 있습니다.`,
    development: [
      "현재의 일상적인 순간에도 의미와 아름다움이 있음을 발견하세요",
      "부정적인 감정에 지나치게 몰입하지 말고 균형을 찾으세요",
      "이상과 현실 사이의 건강한 균형을 맞추세요",
      "자기연민에서 벗어나 객관적인 시각을 기르세요",
      "다른 사람들과의 공통점도 소중하게 여기세요"
    ]
  },
  '5': {
    analysis: `당신은 지적이고 통찰력 있는 관찰자입니다. 지식과 이해를 통해 세상을 파악하려 하며, 독립적인 사고와 개인적 자원을 중요시합니다. 깊이 있는 전문성을 추구하고 자신만의 내적 세계를 구축합니다.

기본적인 두려움은 무능력하고 무력한 존재가 되는 것입니다. 이러한 두려움을 극복하기 위해 지식을 축적하고 자원을 비축하며, 감정적 개입이나 외부 의존도를 최소화하려 합니다.

실제 생활에서는 뛰어난 분석력과 객관적 통찰이 돋보입니다. 예를 들어, 복잡한 문제의 핵심을 정확히 파악하거나, 다른 사람들이 놓친 중요한 패턴과 연결성을 발견합니다. 또한 독립적인 연구나 깊이 있는 탐구를 통해 전문성을 쌓습니다.

통합의 방향은 8번 유형의 특성을 건강하게 받아들이는 것입니다. 통합되면 지적 관찰자의 역할에서 벗어나 더 적극적이고 자신감 있게 세상에 참여하게 되며, 자신의 지식과 통찰을 실제 행동으로 옮길 수 있게 됩니다. 다른 사람들과 더 강력하게 연결되고 영향력을 행사할 수 있습니다.

분열의 방향은 7번 유형의 부정적 특성으로 빠져드는 것입니다. 분열되면 현실의 도전이나 감정적 요구를 회피하기 위해 끊임없이 새로운 정보나 아이디어를 추구하며, 실제적인 참여나 헌신을 피하게 됩니다. 과도한 분석이나 지적 방황으로 실제 행동이 마비될 수 있습니다.`,
    development: [
      "지적 이해를 넘어 실제 경험과 감정에도 참여해보세요",
      "에너지와 자원을 비축하는 것에서 벗어나 더 적극적으로 나누세요",
      "다른 사람들과의 감정적 연결을 두려워하지 마세요",
      "완벽한 준비나 이해 없이도 행동할 수 있다는 것을 받아들이세요",
      "신체적 현존감과 감각적 경험에 더 주의를 기울이세요"
    ]
  },
  '6': {
    analysis: `당신은 충실하고 책임감 있는 충성가입니다. 안전과 안정을 추구하며, 위험과 위협을 미리 예측하고 대비하려 합니다. 신뢰할 수 있는 관계와 시스템을 구축하는 것을 중요시합니다.

기본적인 두려움은 지지와 안내 없이 홀로 남겨지는 것입니다. 이러한 두려움을 극복하기 위해 신뢰할 수 있는 권위나 시스템을 찾거나, 최악의 시나리오를 준비하며 안전장치를 마련합니다.

실제 생활에서는 뛰어난 문제 해결 능력과 충성심이 돋보입니다. 예를 들어, 잠재적 위험을 미리 파악하고 대비책을 마련하거나, 팀과 조직에 헌신적으로 기여하며 신뢰관계를 구축합니다. 또한 다양한 관점에서 상황을 분석하고 실용적인 해결책을 찾아냅니다.

통합의 방향은 9번 유형의 특성을 건강하게 받아들이는 것입니다. 통합되면 불안과 의심에서 벗어나 더 평화롭고 신뢰감 있는 태도를 가지게 되며, 내면의 안정감을 찾을 수 있습니다. 현재 순간을 있는 그대로 받아들이고 자신을 더 신뢰할 수 있게 됩니다.

분열의 방향은 3번 유형의 부정적 특성으로 빠져드는 것입니다. 분열되면 불안을 극복하기 위해 과도하게 성취나 인정을 추구하며, 겉으로는 자신감 있게 보이려 노력하지만 내면의 불안은 더욱 커질 수 있습니다. 지나친 경계심이나 의심으로 관계가 손상될 수 있습니다.`,
    development: [
      "자신의 판단과 직관을 더 신뢰하세요",
      "최악의 시나리오에 덜 집중하고 긍정적 가능성도 보세요",
      "불확실성을 삶의 자연스러운 부분으로 받아들이세요",
      "과도한 분석과 의심에서 벗어나 때로는 믿음으로 행동하세요",
      "현재 순간에 더 집중하고 내면의 평화를 찾으세요"
    ]
  },
  '7': {
    analysis: `당신은 열정적이고 낙관적인 모험가입니다. 새로운 경험과 가능성을 추구하며, 삶의 즐거움과 다양성을 중요시합니다. 고통과 제한을 피하고 항상 긍정적인 선택지를 찾으려 합니다.

기본적인 두려움은 고통과 결핍을 겪는 것입니다. 이러한 두려움을 극복하기 위해 끊임없이 새로운 경험과 즐거움을 추구하며, 부정적인 감정이나 상황을 회피하려 합니다.

실제 생활에서는 창의적인 문제 해결과 긍정적인 에너지가 돋보입니다. 예를 들어, 어려운 상황에서도 새로운 기회를 발견하거나, 다양한 아이디어를 통해 문제를 해결하는 능력이 탁월합니다. 또한 주변 사람들에게 영감과 활력을 불어넣습니다.

통합의 방향은 5번 유형의 특성을 건강하게 받아들이는 것입니다. 통합되면 표면적인 즐거움 추구에서 벗어나 더 깊이 있는 통찰과 집중력을 갖게 되며, 현재의 경험을 더 충실히 누릴 수 있게 됩니다. 감정적 깊이와 지적 성숙도가 증가합니다.

분열의 방향은 1번 유형의 부정적 특성으로 빠져드는 것입니다. 분열되면 자신의 충동적인 행동이나 책임회피에 대해 강한 자책감을 느끼며, 완벽주의적 성향이 증가할 수 있습니다. 과도한 계획이나 규칙 설정으로 오히려 자유를 제한할 수 있습니다.`,
    development: [
      "현재 순간에 더 깊이 머물고 경험을 충분히 소화하세요",
      "불편한 감정도 삶의 중요한 부분임을 인정하세요",
      "책임과 헌신의 가치를 받아들이세요",
      "즐거움 추구와 개인적 성장 사이의 균형을 찾으세요",
      "깊이 있는 관계와 경험의 가치를 인정하세요"
    ]
  },
  '8': {
    analysis: `당신은 강력하고 자신감 있는 지도자입니다. 자신의 영향력을 행사하며 정의와 힘을 추구합니다. 약점을 보이는 것을 꺼리며, 자신과 약자를 보호하려는 강한 의지를 가지고 있습니다.

기본적인 두려움은 다른 사람에게 통제되거나 약점을 보이는 것입니다. 이러한 두려움을 극복하기 위해 강인함과 자기 통제력을 추구하며, 자신의 영역과 권위를 확고히 하려 합니다.

실제 생활에서는 강력한 리더십과 결단력이 돋보입니다. 예를 들어, 어려운 상황에서도 과감한 결정을 내리거나, 불의에 맞서 약자를 보호하는 용기를 보여줍니다. 또한 목표를 향해 강력하게 추진하는 힘이 있습니다.

통합의 방향은 2번 유형의 특성을 건강하게 받아들이는 것입니다. 통합되면 힘과 통제에 대한 집착에서 벗어나 더 부드럽고 이타적인 태도를 갖게 되며, 진정한 친밀감과 취약성을 받아들일 수 있게 됩니다. 다른 사람들의 감정적 필요에 더 민감해집니다.

분열의 방향은 5번 유형의 부정적 특성으로 빠져드는 것입니다. 분열되면 고립되고 냉담해지며, 감정적 단절과 극단적인 독립성을 추구할 수 있습니다. 타인과의 진정한 연결을 두려워하고 회피하게 됩니다.`,
    development: [
      "부드러움과 취약성도 힘이 될 수 있음을 인정하세요",
      "다른 사람들의 감정과 필요에 더 민감하게 반응하세요",
      "통제력을 놓는 것을 두려워하지 마세요",
      "친밀한 관계에서 자신의 약점을 보이는 것을 연습하세요",
      "힘의 사용에 있어 더 섬세한 균형을 찾으세요"
    ]
  },
  '9': {
    analysis: `당신은 평화롭고 수용적인 중재자입니다. 내적, 외적 평화를 추구하며 갈등을 피하려 합니다. 다른 사람들의 관점을 쉽게 이해하고 받아들이지만, 때로는 자신의 존재감과 욕구를 잃어버리기도 합니다.

기본적인 두려움은 상실과 분리입니다. 이러한 두려움을 극복하기 위해 평화와 조화를 추구하며, 갈등이나 불편한 상황을 회피하거나 무시하려 합니다.

실제 생활에서는 뛰어난 중재 능력과 포용력이 돋보입니다. 예를 들어, 갈등 상황에서 양측의 입장을 모두 이해하고 조화로운 해결책을 찾아내거나, 다양한 의견과 관점을 자연스럽게 통합하는 능력이 있습니다.

통합의 방향은 3번 유형의 특성을 건강하게 받아들이는 것입니다. 통합되면 수동성과 회피 성향에서 벗어나 더 적극적이고 목표 지향적인 태도를 갖게 되며, 자신의 존재감과 가치를 분명히 표현할 수 있게 됩니다. 개인적인 성취와 성장을 위해 행동할 수 있습니다.

분열의 방향은 6번 유형의 부정적 특성으로 빠져드는 것입니다. 분열되면 불안과 우유부단함이 증가하며, 결정을 내리지 못하고 끊임없이 걱정하게 됩니다. 다른 사람들에게 과도하게 의존하거나 지나치게 경계하는 모습을 보일 수 있습니다.`,
    development: [
      "자신의 의견과 욕구를 더 분명하게 인식하고 표현하세요",
      "갈등을 회피하지 말고 건설적으로 다루는 법을 배우세요",
      "편안함의 영역에서 벗어나 적극적으로 행동하세요",
      "현재에 더 깊이 집중하고 자신의 존재감을 느끼세요",
      "자신의 삶에서 주도적인 역할을 맡으세요"
    ]
  }
} 